import React from 'react';

class NotFoundPage extends React.Component {
  render() {
    return (
      <div>
        <div>This is not the page you are looking for...</div>
      </div>
    )
  }
}

export default NotFoundPage;